<template>
  <div>
    <app-header />

    <div class="container container-fluid mt-4 mb-4">
      <div class="card">
        <div class="card-body">
          <h2 class="mb-4">Stage Lead Times</h2>
          <ul class="list-data no-links list-data-card">
            <li v-for="stage in stages" :key="stage.id">
              <div class="row">
                <div class="col pt-2">
                  <p class="label">{{ stage.name }}</p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <c-input
                    as="multiselect"
                    :options="options"
                    type="text"
                    v-model="stage.lead_time"
                    :show-labels="false"
                    @input="updateStageLeadTime(stage)"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, notify } from 'utils'

export default {
  data() {
    return {
      stages: [],
      options: ['1 Week', '2 Weeks', '3 Weeks', '4 Weeks', '5 Weeks', '6 Weeks', '2 Months', '3 Months', '4 Months', '5 Months', '6 Months'],
    }
  },

  async created() {
    try {
      const response = await http.get(`settings/stages`)
      this.stages = response.data.data
    } catch (e) {
      notify.error('Something went wrong retreiving stages.')
    }
  },

  methods: {
    async updateStageLeadTime(stage) {
      try {
        const response = await http.put(`settings/stages/${stage.id}`, { lead_time: stage.lead_time })
      } catch (e) {
        notify.error('Something went wrong updating stage lead time')
      }
    },
  },
}
</script>
